export const ADMIN = 'admin';
export const CLIENT = 'client';

export default {
  ADMIN,
  CLIENT,
};
